import { render, staticRenderFns } from "./CardHorisontal.vue?vue&type=template&id=7b39eae6&scoped=true&"
import script from "./CardHorisontal.vue?vue&type=script&lang=js&"
export * from "./CardHorisontal.vue?vue&type=script&lang=js&"
import style0 from "./CardHorisontal.vue?vue&type=style&index=0&id=7b39eae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b39eae6",
  null
  
)

export default component.exports